import React from 'react';
import { normalizeFeatureValue } from '../../utils/featureNormalization';
import { sortFeatureValues } from '../../utils/sortingUtils';
import { formatCurrency, getValuePrice, getValueSwatchColor, getValueThumbnail } from '../../utils/valuePresentation';

const Swatches = ({ feature, value, onChange, disabled = false, isOptionDisabled, className = '' }) => {
    const schema = feature?.valueSchema || feature?.property?.valueSchema || [];
    const values = sortFeatureValues((feature?.values || []).map(normalizeFeatureValue));
    const currentValue = value === undefined || value === null ? '' : String(value);
    const selected = values.find(item => String(item.value) === currentValue);

    return (
        <div className={className} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <div style={{ display: 'flex', gap: '0.55rem', flexWrap: 'wrap' }}>
                {values.map(item => {
                    const valKey = String(item.value ?? '');
                    const swatch = getValueSwatchColor(item, schema, feature);
                    const thumb = getValueThumbnail(item, schema, feature);
                    const optionDisabled = disabled || Boolean(isOptionDisabled?.(valKey));
                    const selectedOption = valKey === currentValue;
                    return (
                        <button
                            key={item.id || valKey}
                            type="button"
                            title={item.displayText || item.value}
                            disabled={optionDisabled}
                            onClick={() => !optionDisabled && onChange?.({ target: { value: valKey } })}
                            style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '999px',
                                border: selectedOption ? '2px solid var(--accent)' : '1px solid var(--border)',
                                background: swatch || '#e5e7eb',
                                backgroundImage: !swatch && thumb ? `url(${thumb})` : undefined,
                                backgroundSize: 'cover',
                                cursor: optionDisabled ? 'not-allowed' : 'pointer',
                                opacity: optionDisabled ? 0.4 : 1
                            }}
                        />
                    );
                })}
            </div>
            {selected && (
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                    {selected.displayText || selected.value}
                    {getValuePrice(selected, schema, feature) !== '' && ` · ${formatCurrency(getValuePrice(selected, schema, feature))}`}
                </div>
            )}
        </div>
    );
};

export default Swatches;
